import { AppState } from "..";

export const getInfoWindowState = (key: string) => (state: AppState) =>
  state.map.markerInfoWindowState[key] || false;

export const zoomSelector = (state: AppState) => state.map.zoom;
export const centerSelector = (state: AppState) => state.map.center;
